import { makeStyles } from '@mui/styles';
import { IconButton, Tooltip } from 'apollo-react';
import Redo from 'apollo-react-icons/Redo';
import Undo from 'apollo-react-icons/Undo';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from './../../../../custom-hooks/useTranslation';
import { getUITA } from '../../../../utils/commonUtils';
import { redoUserAction, undoUserAction } from '../../../actions/report-model-designer.actions';
import { isRedoDisabled, isUndoDisabled } from '../../../selectors/report-model-designer.selectors';
import { equalityFn } from '../../../utils/report-model-designer-utils';

const useStyles = makeStyles({
  buttonContainer: {
    display: 'flex',
  },
  actionButton: {
    paddingTop: '4px',
    width: '22px',
    height: '22px',
  },
});

const UserChangesButtons = () => {
  const translateString = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();

  const isRedoButtonDisabled = useSelector(isRedoDisabled, equalityFn);
  const isUndoButtonDisabled = useSelector(isUndoDisabled, equalityFn);

  const handleRedoButtonClick = () => dispatch(redoUserAction());
  const handleUndoButtonClick = () => dispatch(undoUserAction());

  return (
    <div className={classes.buttonContainer}>
      <Tooltip title={isUndoButtonDisabled ? null : translateString('Undo Action')} placement="top">
        <IconButton
          aria-label={translateString('Undo Action')}
          style={{ marginRight: 5 }}
          size="small"
          onClick={handleUndoButtonClick}
          ui-ta={getUITA('undo-action')}
          disabled={isUndoButtonDisabled}
        >
          <Undo fontSize="small" className={classes.actionButton} />
        </IconButton>
      </Tooltip>
      <Tooltip title={isRedoButtonDisabled ? null : translateString('Redo Action')} placement="top">
        <IconButton
          aria-label={translateString('Redo Action')}
          style={{ marginRight: 5 }}
          size="small"
          onClick={handleRedoButtonClick}
          ui-ta={getUITA('redo-action')}
          disabled={isRedoButtonDisabled}
        >
          <Redo fontSize="small" className={classes.actionButton} />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default UserChangesButtons;
